import { render } from "./Diagnosis.vue?vue&type=template&id=5de9bfd6"
import script from "./Diagnosis.vue?vue&type=script&lang=js"
export * from "./Diagnosis.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Diagnosis.vue?vue&type=style&index=0&id=5de9bfd6&lang=scss&module=s"
cssModules["s"] = style0
import "./Diagnosis.vue?vue&type=style&index=1&id=5de9bfd6&lang=scss"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__